// src/frontend_react/src/components/ui/Select/Select.js
import React from 'react';
import Typography from '../Typography/Typography';
import styles from './Select.module.css';
import Box from '../Box/Box';

const Select = ({
  id,
  label,
  labelSrOnly,
  value,
  onChange,
  options = [],
  placeholder,
  disabled,
  required,
  error,
  hint,
  selectName,
  containerProps = {},
  className,
  selectClassName,
  ...rest
}) => {
  const selectId = id || `select-${selectName || Math.random().toString(36).substr(2, 9)}`;
  const hasError = !!error;
  const descriptionText = hint;

  // Destructure layout props from ...rest to apply them to the Box
  const { alignSelf, flexGrow, mt, mb, mx, my, m, ...selectProps } = rest;

  return (
    <Box
      className={`${styles.selectWrapper} ${hasError ? styles.errorState : ''} ${className || ''}`}
      {...containerProps} 
      alignSelf={alignSelf}
      flexGrow={flexGrow}
      mt={mt} mb={mb} mx={mx} my={my} m={m}
    >
      {label && (
        <Typography
          as="label"
          htmlFor={selectId}
          className={`${styles.label} ${labelSrOnly ? 'sr-only' : ''}`}
        >
          {label}
          {required && <span className={styles.requiredIndicator}>*</span>}
        </Typography>
      )}
      <div className={styles.selectContainer}>
        <select
          id={selectId}
          name={selectName}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          className={`${styles.select} ${selectClassName || ''}`}
          aria-invalid={hasError}
          aria-describedby={descriptionText || error ? `${selectId}-description` : undefined}
          {...selectProps} // Spread only valid attributes here
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {(descriptionText && !hasError) && (
        <Typography variant="caption" color="secondary" id={`${selectId}-description`} className={styles.hintText}>
          {descriptionText}
        </Typography>
      )}
      {hasError && (
        <Typography variant="caption" color="error" id={`${selectId}-description`} className={styles.errorMessageText} role="alert">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default Select;